export const defaultOrderUserFormValues = {
  name: "",
  telephone: "",
  email: "",
  zip_code: "",
  house_number: "",
  street_name: "",
  city: "",
};
